import { render, staticRenderFns } from "./supplySolutions.vue?vue&type=template&id=722f66fb&scoped=true&"
import script from "./supplySolutions.vue?vue&type=script&lang=js&"
export * from "./supplySolutions.vue?vue&type=script&lang=js&"
import style0 from "./supplySolutions.vue?vue&type=style&index=0&id=722f66fb&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722f66fb",
  null
  
)

export default component.exports